import React from 'react';
import { Link } from 'react-router-dom';
import {
    message,
    Table,
    Tabs,
    Radio,
    Button,
    Popover,
    Modal,
    Form,
    Pagination,
    Row,
    Col,
    Icon,
    Input,
    Select,
    DatePicker,
    Spin,
} from 'antd';
const { Column } = Table;
const FormItem = Form.Item;
const RangePicker = DatePicker.RangePicker;
const TabPane = Tabs.TabPane;
const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
import { dateConversion, stringToTime, getDateBetween, paramsEncode } from '../../../utils';
import Urls from '../../../../config';
const getDownloadUrl = Urls.TaskStatisticUrl.exportData;
const getDownloadUrlV2 = Urls.TaskStatisticUrl.exportDataV2;
const getListUrl =  Urls.TaskExcutionUrl.getListUrl;
const getAdListUrl = Urls.TaskExcutionUrl.getAdListUrl;
import { getIndexList ,getAdvertismentList,getStandarlineTreeList} from './actions';
import { connect } from 'react-redux';
import constant from './constant';
import moment from 'moment';
import {StandarLineList} from "./reducers";

class NewExportData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            eIds: undefined,
            taskIds: undefined,
            taskId: undefined, //任务id
            adId:undefined,//广告Id
            ps:undefined,//广告位编号
            beginDate: moment().format('YYYY-MM-DD'), //开始时间
            endDate: moment().format('YYYY-MM-DD'), //结束时间
            downloadUrl: getDownloadUrl,
            downloadUrlV2: getDownloadUrlV2,
            type:0,//聚合类型
            taskDescription: undefined,//订单名称
            taskName: undefined//任务名称
        };
    }

    componentDidMount() {
        const param = {
            beginDate: moment().format('YYYY-MM-DD'), //开始时间
            endDate: moment().format('YYYY-MM-DD'), //结束时间
        }
        let paramStr = getListUrl + paramsEncode(param).replace(/\&/, '?');
        let paramAdtr = getAdListUrl + paramsEncode(param).replace(/\&/, '?');
        //this.props.getIndexList(paramStr);
        //this.props.getAdvertismentList(paramAdtr);
        this.props.getStandarlineTreeList();
    }
    async changeTaskDescription(taskDescription) {
      console.log(this.state);
        let paramStr = '';
        const param = {
            eIds: this.state.eIds,
            taskIds: this.state.taskIds,
            taskId: this.state.taskId, //任务id
            adId:this.state.adId,//广告Id
            ps:this.state.ps,//广告位编号
            beginDate: this.state.beginDate, //开始时间
            endDate: this.state.endDate, //结束时间
            type: this.state.type,//聚合类型
            taskDescription: taskDescription.target.value,
            taskName: this.state.taskName
        };
        paramStr = getDownloadUrlV2 + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            taskDescription: taskDescription.target.value,
            downloadUrlV2: paramStr,
        });
    }
    async changeTaskName(taskName) {
      console.log(this.state);
        let paramStr = '';
        const param = {
            eIds: this.state.eIds,
            taskIds: this.state.taskIds,
            taskId: this.state.taskId, //任务id
            adId:this.state.adId,//广告Id
            ps:this.state.ps,//广告位编号
            beginDate: this.state.beginDate, //开始时间
            endDate: this.state.endDate, //结束时间
            type: this.state.type,//聚合类型
            taskDescription: this.state.taskDescription,
            taskName: taskName.target.value
        };
        paramStr = getDownloadUrlV2 + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            taskName: taskName.target.value,
            downloadUrlV2: paramStr,
        });
    }
    async changeTaskId(id) {
        let paramStr = '';
        const param = {
            eIds: this.state.eIds,
            taskIds: id,
            adId:this.state.adId,//广告Id
            ps:this.state.ps,//广告位编号
            beginDate: this.state.beginDate, //开始时间
            endDate: this.state.endDate, //结束时间
            type: this.state.type,//聚合类型
            taskDescription: this.state.taskDescription,
            taskName: this.state.taskName
        };
        paramStr = getDownloadUrlV2 + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            taskIds: id,
            downloadUrlV2: paramStr,
        });
    }
    async changeAdId(id) {
      let paramStr = '';
      const param = {
          eIds: id,
          taskIds: this.state.taskIds,
          ps:this.state.ps,//广告位编号
          beginDate: this.state.beginDate, //开始时间
          endDate: this.state.endDate, //结束时间
          type: this.state.type,//聚合类型
          taskDescription: this.state.taskDescription,
          taskName: this.state.taskName
      };
      paramStr = getDownloadUrlV2 + paramsEncode(param).replace(/\&/, '?');
      await this.setState({
          eIds: id,
          downloadUrlV2: paramStr,
      });
    }
    async changePs(id) {
      let paramStr = '';
      const param = {
          eIds: this.state.eIds,
          taskIds: this.state.taskIds,
          adId:this.state.adId,//广告Id
          ps:id.target.value,//广告位编号
          beginDate: this.state.beginDate, //开始时间
          endDate: this.state.endDate, //结束时间
          type: this.state.type,//聚合类型
          taskDescription: this.state.taskDescription,
          taskName: this.state.taskName
      };
      paramStr = getDownloadUrlV2 + paramsEncode(param).replace(/\&/, '?');
      await this.setState({
          ps: id.target.value,
          downloadUrlV2: paramStr,
      });
    }
    async changeType(id) {
      let paramStr = '';
      const param = {
          eIds: this.state.eIds,
          taskIds: this.state.taskIds,
          adId:this.state.adId,//广告Id
          ps:this.state.ps,//广告位编号
          beginDate: this.state.beginDate, //开始时间
          endDate: this.state.endDate, //结束时间
          type: id,//聚合类型
          taskDescription: this.state.taskDescription,
          taskName: this.state.taskDescription
      };
      paramStr = getDownloadUrlV2 + paramsEncode(param).replace(/\&/, '?');
      await this.setState({
          type: id,
          downloadUrlV2: paramStr,
      });
    }
    async changeData(a, b) {
        let paramStr = '';
        const param = {
            eIds: this.state.eIds,
            taskIds: this.state.taskIds,
          adId:this.state.adId,//广告Id
          ps:this.state.ps,//广告位编号
          beginDate: b[0], //开始时间
          endDate: b[1], //结束时间
          type: this.state.type,//聚合类型
          taskDescription: this.state.taskDescription,
          taskName: this.state.taskName
        };
        paramStr = getDownloadUrlV2 + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            beginDate: b[0],
            endDate: b[1],
            downloadUrlV2: paramStr,
        });
    }
    async download(){
        if(this.state.beginDate == undefined || this.state.beginDate == undefined ||
            this.state.beginDate == null || this.state.beginDate == null ||
            this.state.beginDate == '' || this.state.beginDate == ''){
            message.info('请输入开始时间和结束时间!');
            return ;
        }
        //下载文件
        const aLink = document.createElement('a');
        document.body.appendChild(aLink);
        aLink.style.display='none';
        aLink.href = this.state.downloadUrlV2;
        aLink.download = "fileName";
        aLink.click();
        document.body.removeChild(aLink);
    }

    async reset(){
        let paramStr = '';
        const param = {
            eIds: [],
            taskIds: [],
            adId:"",//广告Id
            ps:"",//广告位编号
            beginDate: "", //开始时间
            endDate:"", //结束时间
            type: 0,//聚合类型
            taskDescription: "",
            taskName: ""
        };
        paramStr = getDownloadUrlV2 + paramsEncode(param).replace(/\&/, '?');
        await this.setState({
            eIds: [],
            taskIds: [],
            adId:"",//广告Id
            ps:"",//广告位编号
            beginDate: "", //开始时间
            endDate:"", //结束时间
            type: 0,//聚合类型
            taskDescription: "",
            taskName: "",
            downloadUrlV2: paramStr,
        });
    }

    async query(){
        if(this.state.beginDate == undefined || this.state.beginDate == undefined ||
            this.state.beginDate == null || this.state.beginDate == null ||
            this.state.beginDate == '' || this.state.beginDate == ''){
            message.info('请输入开始时间和结束时间!');
            return ;
        }
        let paramStr = '';
        const param = {
            eIds: this.state.eIds,
            taskIds: this.state.taskIds,
            adId:this.state.adId,//广告Id
            ps:this.state.ps,//广告位编号
            beginDate: this.state.beginDate, //开始时间
            endDate: this.state.endDate, //结束时间
            type: this.state.type,//聚合类型
            taskDescription: this.state.taskDescription,
            taskName: this.state.taskName
        };
        paramStr = getListUrl + paramsEncode(param).replace(/\&/, '?');
        let paramAdtr = getAdListUrl + paramsEncode(param).replace(/\&/, '?');
        this.props.getIndexList(paramStr);
        this.props.getAdvertismentList(paramAdtr);
    }

     getAdComplete( key,indexAdList,record){
        let obj = indexAdList[key];
        if(obj) {
            if ("EV" == record.taskType) {
                 if(obj.tc==0){
                     return   obj.actualExpo;
                 }else{
                     return  obj.optTotal;
                 }
            } else {
                if(obj.tc == 0) {
                   return   obj.actualClick;
                }else{
                    return obj.clcTotal;
                }
            }
        }
     }
    getAdCompleteOut( key,indexAdList,record){
        let obj = indexAdList[key];
        if(obj) {
          return  obj.optTotal+"/"+obj.clcTotal;
        }
        return "";
    }
    getAdCompleteRate( key,indexAdList,record){
        let obj = indexAdList[key];
        if(obj) {
            if ("EV" == record.taskType) {
              return obj.preExpoRate;
            } else {
                return obj.preClickRate;
            }
        }
    }
    getAdCompleteRateOut(key,indexAdList,record){
        let obj = indexAdList[key];
        if(obj) {
            return obj.preExpoRate+"/"+obj.preClickRate;
        }
    }
    getAdExpectRate( key,indexAdList,record){
        let obj = indexAdList[key];
        if(obj) {
            if ("EV" == record.taskType) {
                return obj.uvHopeRate;
            } else {
                return obj.clickHopeRate;
            }
        }
    }
    getAdExpectRateOut( key,indexAdList,record){
        let obj = indexAdList[key];
        if(obj) {
            return obj.uvHopeRate+"/"+obj.clickHopeRate;
        }
    }
    AllcaculateExpectRate(task){
        let listChild = task.listChild;
        let expectNum=0;
        let targetPv=0;
        for(let i =0;i<listChild.length;i++){
            this.caculateExpectRate(listChild[i]);
            expectNum+=listChild[i].expectNum;
            targetPv+= listChild[i].targetPv;
        }
       return Math.round(100*expectNum/targetPv)/100.0;
    }
    AllOutcaculateExpectRate(task){
        let listChild = task.listChild;
        let expectNumEv=0;
        let targetPvEv=0;
        let expectNumClick=0;
        let targetPvClick=0;
        for(let i =0;i<listChild.length;i++){
            this.caculateExpectRate(listChild[i]);
            if("EV"==listChild[i].taskType){
                expectNumEv+=listChild[i].expectNum;
                targetPvEv+= listChild[i].targetPv;
            }else{
                expectNumClick+=listChild[i].expectNum;
                targetPvClick+= listChild[i].targetPv;
            }
        }

        let evExpectRate="";
        let clickExpectRate="";
        if(targetPvEv!=0) {
            evExpectRate = Math.round(100 * expectNumEv / targetPvEv) / 100.0;
        }
        if(targetPvClick!=0){
            clickExpectRate= Math.round(100*expectNumClick/targetPvClick)/100.0;
        }
        return evExpectRate+"/"+clickExpectRate;
    }
     caculateExpectRate(task){
        let standarline = this.props.StandarLineList;
        let curve =  (task.curve==undefined||task.curve=="")? task.platform:task.curve;
        if(curve == undefined || curve ==""){
            return ;
        }
        let standar = standarline[curve];
        let timeDay = task.taskCreateTime.split(" ");
        let begin = task.timePairs[0].beginTime;
        if(timeDay[0] == task.dateTime){
            //取begintime和createTime的最大值
            let createTimebegin = parseInt(timeDay[1].replace(":", "").substring(0, 4));
            begin = Math.max(begin,createTimebegin);
        }
        let sumStandard =0;
        let now = new Date();
        let nowint = parseInt(now.getHours()+""+(now.getMinutes()<10? (0+""+now.getMinutes()) : now.getMinutes()));
        let nowSum =0;
       /* for(let i = begin;i<=begin,task.timePairs[0].endTime;i++){
            let standarchild =standar[i];
            if(standarchild != undefined){
                sumStandard+=standarchild[0].num;
                if(nowint>=i){
                    nowSum+=standarchild[0].num;
                }
            }
        }*/
         sumStandard =  this.querySum(begin,task.timePairs[0].endTime,1,standar);
         nowSum = this.querySum(begin,nowint,1,standar);
        //console.log(task.taskId+"-"+begin+"-"+task.timePairs[0].endTime+"-"+nowSum+"-"+sumStandard);
        let expectComplete = 100+(task.expectOverFlow==undefined ? 30:task.expectOverFlow);
        let expectCompleteRate =   nowSum*expectComplete/(sumStandard*100.0);
        task.expectNum=expectCompleteRate*task.targetPv;
        task.expectCompleteRate= expectCompleteRate;
        return Math.round(expectCompleteRate * 100) / 100;
    }
    querySum(L,R,rt,map){
        let standardLineTree = map[rt];
        if(standardLineTree == undefined){
            return 0;
        }else{
            let left  = standardLineTree.left;
            let right = standardLineTree.rigt;
            if(right == R && left == L){
                return standardLineTree.num;
            }else{
                let mid  = (left+right)>>1;
                let lrt = rt<<1;
                let rrt = rt<<1|1;
                if(R<=mid){
                    return this.querySum(L,R,lrt,map);
                }else if(L>=mid){
                    return this.querySum(L,R,rrt,map);
                }else{
                    return this.querySum(L,mid,lrt,map)+this.querySum(mid+1,R,rrt,map);
                }
            }
        }
    }
    render() {
        const { indexList ,indexAdList} = this.props;
        const {outAdMList,cpmAdList,normalAdList} = indexList;
        if(normalAdList) {
            normalAdList.map(item => {
                item.key = item.index;
                return item;
            });
        }
        if(cpmAdList) {
            cpmAdList.map(item => {
                item.key = item.index;
                item['listChild'].map(item => {
                    item.key = item.index;
                    return item;
                })
                return item;
            });
        }
        if(outAdMList) {
            outAdMList.map(item => {
                item.key = item.index;
                item['listChild'].map(item => {
                    item.key = item.index;
                    return item;
                })
                return item;
            });
        }
        const cpmAdListColumns = [
            {
                title: 'eId',
                dataIndex: 'eId',
                key: 'eId',
            },
            {
                title: '资源包Id',
                dataIndex: 'cpmId',
                key: 'cpmId',
            },
            {
                title: 'resceId',
                dataIndex: 'resceId',
                key: 'resceId',
            },
            {
                title: '任务名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: '任务类型',
                dataIndex: 'taskType',
                key: 'taskType',
            },
            {
                title: '目标量',
                dataIndex: 'targetPv',
                key: 'targetPv',
            },
            {
                title: '恒紫完成量',
                dataIndex: 'complete',
                key: 'complete',
            },
            {
                title: '恒紫完成率',
                dataIndex: 'completeRate',
                key: 'completeRate',
                render: (text,record) => {
                    if(record.targetPv!=0&&record.targetPv!=undefined){
                        return (record.complete/record.targetPv).toFixed(3);
                    }
                    return "";
                },
            },
            {
                title: '期望完成率',
                dataIndex: '123',
                key: '123',
                render: (text,record) => {
                    return this.AllcaculateExpectRate(record);
                }
            },
            {
                title: '期望溢出',
                dataIndex: '12',
                key: '12',
                render: (text,record) => {
                    return record.listChild[0].expectOverFlow==undefined? 30:record.listChild[0].expectOverFlow;
                }
            },
            {
                title: '广告系统完成量',
                dataIndex: '21121',
                key: '2121',
                render: (text,record) => {
                    let key = record.eId+record.cpmId+record.tm+record.taskType;
                    let result=this.getAdComplete(key,indexAdList,record);
                   return <Spin spinning={this.props.adloading} tip="">
                       {result}
                    </Spin>
                }
            },
            {
                title: '广告系统完成率',
                dataIndex: '211212',
                key: '21221',
                render: (text,record) => {
                    let key = record.eId+record.cpmId+record.tm+record.taskType;
                    let result=this.getAdCompleteRate(key,indexAdList,record);
                    return <Spin spinning={this.props.adloading} tip="">
                        {result}
                    </Spin>
                }
            },
            {
                title: '广告系统期望',
                dataIndex: 'hopeRate',
                key: 'hopeRate',
                render: (text,record) => {
                    let key = record.eId+record.cpmId+record.tm+record.taskType;
                    let result=this.getAdExpectRate(key,indexAdList,record);
                    return <Spin spinning={this.props.adloading} tip="">
                        {result}
                    </Spin>
                }
            },
            {
                title: '设备类型',
                dataIndex: 'deviceInfo',
                key: 'deviceInfo',
            },
        ];
        const outAdMListColumns =[
            {
                title: '日期',
                dataIndex: 'tm',
                key: 'tm',
            },
            {
                title: 'eId',
                dataIndex: 'eId',
                key: 'eId',
            },
            {
                title: '任务名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: '曝光目标量',
                dataIndex: 'targetEv',
                key: 'targetEv',
            },
            {
                title: '恒紫曝光完成量',
                dataIndex: 'completeEv',
                key: 'completeEv',
            },
            {
                title: '点击目标量',
                dataIndex: 'targetClick',
                key: 'targetClick',
            },
            {
                title: '恒紫点击完成量',
                dataIndex: 'completeClick',
                key: 'completeClick',
            },
            {
                title: '恒紫曝光完成率',
                dataIndex: 'completeEvRate',
                key: 'completeEvRate',
                render: (text,record) => {
                    if(record.targetEv!=0&&record.targetEv!=undefined){
                        return (record.completeEv/record.targetEv).toFixed(3);
                    }
                    return "";
                },
            },
            {
                title: '恒紫点击完成率',
                dataIndex: 'completeClickRate',
                key: 'completeClickRate',
                render: (text,record) => {
                    if(record.targetClick!=0&&record.targetClick!=undefined){
                        return (record.completeClick/record.targetClick).toFixed(3);
                    }
                    return "";
                },
            },
            {
                title: '期望完成率(EV/CLICK)',
                dataIndex: '123',
                key: '123',
                render: (text,record) => {
                    return this.AllOutcaculateExpectRate(record);
                }
            },
            {
                title: '期望溢出(EV/CLICK)',
                dataIndex: '12',
                key: '12',
                render: (text,record) => {
                    //return record.listChild[0].expectOverFlow==undefined? 30:record.listChild[0].expectOverFlow;
                    let expectOverFlowEv="";
                    let expectOverFlowClick="";
                    for(let i=0;i< record.listChild.length;i++){
                        if("EV"==record.listChild[i].taskType){
                            expectOverFlowEv = record.listChild[i].expectOverFlow==undefined? 30:record.listChild[i].expectOverFlow;
                        }else{
                            expectOverFlowClick = record.listChild[i].expectOverFlow==undefined? 30:record.listChild[i].expectOverFlow;
                        }
                        if(expectOverFlowEv!=""&&expectOverFlowClick!=""){
                            break;
                        }
                    }
                    return expectOverFlowEv+"/"+expectOverFlowClick;
                }
            },
            {
                title: '广告系统完成量(EV/CLICK)',
                dataIndex: '21121',
                key: '2121',
                render: (text,record) => {
                    let keyE = record.eId+record.taskName+record.tm;
                    let result=this.getAdCompleteOut(keyE,indexAdList,record);
                    return <Spin spinning={this.props.adloading} tip="">
                        {result}
                    </Spin>
                }
            },
            {
                title: '广告系统完成率(EV/CLICK)',
                dataIndex: '122',
                key: '122',
                render: (text,record) => {
                    let keyE = record.eId+record.taskName+record.tm;
                    let result=this.getAdCompleteRateOut(keyE,indexAdList,record);
                    return <Spin spinning={this.props.adloading} tip="">
                        {result}
                    </Spin>
                }
            },
            {
                title: '广告系统期望(EV/CLICK)',
                dataIndex: 'exp',
                key: 'exp',
                render: (text,record) => {
                    let keyE = record.eId+record.taskName+record.tm;
                    let result=this.getAdExpectRateOut(keyE,indexAdList,record);
                    return <Spin spinning={this.props.adloading} tip="">
                        {result}
                    </Spin>
                }
            },
            {
                title: '设备类型',
                dataIndex: 'deviceInfo',
                key: 'deviceInfo',
            },
        ];
        const normalAdListColumns = [
            {
                title: 'taskId',
                dataIndex: 'taskId',
                key: 'taskId',
            },
            {
                title: 'eId',
                dataIndex: 'eId',
                key: 'eId',
            },
            {
                title: 'ps',
                dataIndex: 'ps',
                key: 'ps',
            },
            {
                title: '时间',
                dataIndex: 'dateTime',
                key: 'dateTime',
            },
            {
                title: '任务名称',
                dataIndex: 'taskName',
                key: 'taskName',
            },
            {
                title: '目标量',
                dataIndex: 'targetPv',
                key: 'targetPv',
            },
            {
                title: '期望溢出',
                dataIndex: 'expectOverFlow',
                key: 'expectOverFlow',
                render:(text,record) =>{
                    if(text == undefined){
                        return 30;
                    }else{
                        return text;
                    }
                }
            },
            {
                title: '恒紫期望率',
                dataIndex: 'expectComRate',
                key: 'expectComRate',
            },
            // {
            //     title: '期望完成率',
            //     dataIndex: '123',
            //     key: '123',
            //     render:(text,record) =>{
            //         return this.caculateExpectRate(record);
            //     }
            // },
            {
                title: '恒紫完成量',
                dataIndex: 'completeNum',
                key: 'completeNum',
            },
            {
                title: '恒紫完成率',
                dataIndex: 'completeRate',
                key: 'completeRate',
                render: (text,record) => {
                    if(record.targetPv!=0&&record.targetPv!=undefined){
                        return (record.completeNum/record.targetPv).toFixed(2);
                    }
                    return "";
                },
            },
            {
                title: '广告系统完成量',
                dataIndex: 'com',
                key: 'com',
                render: (text,record) => {
                    let key = record.eId+record.ps+record.tm+record.taskType;
                    let result=this.getAdComplete(key,indexAdList,record);
                    return <Spin spinning={this.props.adloading} tip="">
                        {result}
                    </Spin>
                }
            },
            {
                title: '广告系统完成率',
                dataIndex: 'comr',
                key: 'comr',
                render: (text,record) => {
                    let key = record.eId+record.ps+record.tm+record.taskType;
                    let result=this.getAdCompleteRate(key,indexAdList,record);
                    return <Spin spinning={this.props.adloading} tip="">
                        {result}
                    </Spin>
                }
            },
            {
                title: '广告系统期望',
                dataIndex: 'hopeRate',
                key: 'hopeRate',
                render: (text,record) => {
                    let key = record.eId+record.ps+record.tm+record.taskType;
                    let result=this.getAdExpectRate(key,indexAdList,record);
                    return <Spin spinning={this.props.adloading} tip="">
                        {result}
                    </Spin>
                }
            },
            {
                title: '设备类型',
                dataIndex: 'deviceInfo',
                key: 'deviceInfo',
            },
            ];
        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>任务统计导出</h2>
                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>
                    <label>
                        任务ID：
                        <Select  mode="tags" placeholder="任务id" style={{ width: 120 }} onChange={this.changeTaskId.bind(this)}

                                 value={this.state.taskIds} />
                    </label>
                    <label>
                        广告ID：
                        <Select  mode="tags" placeholder="广告id" style={{ width: 120 }} onChange={this.changeAdId.bind(this)}

                                 value={this.state.eIds}
                        />
                    </label>
                    <label>
                        订单名称：
                        <Input placeholder="订单名称" style={{ width: 120 }} onChange={this.changeTaskDescription.bind(this)}
                               defaultValue={this.state.taskDescription}
                               value={this.state.taskDescription}
                        />
                    </label>
                    <label>
                        任务名称：
                        <Input placeholder="任务名称" style={{ width: 120 }} onChange={this.changeTaskName.bind(this)}
                               defaultValue={this.state.taskName}
                               value={this.state.taskName}
                        />
                    </label>
                    <label>
                        PS：
                        <Input placeholder="ps" style={{ width: 120 }} onChange={this.changePs.bind(this)}
                               defaultValue={this.state.ps}
                               value={this.state.ps}
                        />
                    </label>
                </div>

                <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>
                    <label>
                      聚合维度：
                      {/*<RadioGroup value={this.state.type} onChange={this.changeType.bind(this)}>
                          <RadioButton value={0}>天</RadioButton>
                          <RadioButton value={1}>小时</RadioButton>
                      </RadioGroup>*/}
                        <Select onChange={this.changeType.bind(this)} value={this.state.type} style={{width:'76px'}}
                                value={this.state.type}
                        >
                            <RadioButton value={0}>天</RadioButton>
                            <RadioButton value={1}>小时</RadioButton>
                            <RadioButton value={2}>天(单sheet)</RadioButton>
                        </Select>,
                    </label>
                    <label>
                        日期：
                        <RangePicker
                            format="YYYY-MM-DD"
                            onChange={(value, dateString) => this.changeData(value, dateString)}
                            value={(this.state.beginDate==undefined ||this.state.beginDate=="") ? [] :[moment(this.state.beginDate,'YYYY-MM-DD'),moment(this.state.endDate,'YYYY-MM-DD')]}
                        />
                    </label>
                    <Button type="primary" onClick={this.download.bind(this)} >
                        {/*<a href={this.state.downloadUrlV2} download="filename">
                            导出数据
                        </a>*/}
                        导出数据
                    </Button>
                </div>
                <br/>
                <div >
                    <Button type="primary" onClick={this.reset.bind(this)} style={{"left":"40%"}}>
                        重置
                    </Button>
                    <Button type="primary" onClick={this.query.bind(this)} style={{"left":"45%"}}>
                        搜索
                    </Button>
                </div>

                <br/>
                <Spin spinning={this.props.loading} tip="加载中...">
                    <Tabs defaultActiveKey="1">
                        <TabPane tab="普通任务" key="1">
                            <Table
                                columns={normalAdListColumns}
                                dataSource={normalAdList}
                                pagination={false}
                                defaultExpandAllRows={false}
                            />
                        </TabPane>
                        <TabPane tab="外部任务" key="2">
                            <Table
                                columns={outAdMListColumns}
                                dataSource={outAdMList}
                                pagination={false}
                                defaultExpandAllRows={false}
                            />
                        </TabPane>
                        <TabPane tab="CPM任务" key="3">
                            <Table
                                columns={cpmAdListColumns}
                                dataSource={cpmAdList}
                                pagination={false}
                                defaultExpandAllRows={false}
                            />
                        </TabPane>
                    </Tabs>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.newExportData.ListStatus.loading,
    adloading: state.newExportData.ListStatus.adloading,
    indexList: state.newExportData.IndexList,
    indexAdList: state.newExportData.IndexAdList,
    StandarLineList: state.newExportData.StandarLineList,
});

const mapDispatchToProps = dispatch => ({
    getIndexList: prarms => dispatch(getIndexList(prarms)),
    getAdvertismentList: params => dispatch(getAdvertismentList(params)),
    getStandarlineTreeList: () => dispatch(getStandarlineTreeList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NewExportData);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/newExportData/index.js